

<div class="center">
    <p style="margin-left: 40px;font-weight: bold;font-size: 150px">404</p>

</div>
<div class="center">
    <p style="margin-left: 40px;font-weight: bold;font-size: 70px">page not found</p>
</div>
